import React from 'react';
import { ModalCard } from 'components/cards/ModalCard';
import { Grid } from 'components/layout/Grid';
import welcomeImgSrc from 'assets/media/lkf/onboarding-welcome.png';
import { Text } from 'components/typography/Text';
import { Brikk } from 'components/Brikk';
import { NextStep } from 'components/form-elements/buttons/NextStep';
import { useRedirect } from 'utils/redirect';
import { OnboardingGrid } from 'pages/onboarding/OnboardingGrid';
import { LKFOnboardingRoutes } from '../../routes';
import { ImageGalleryOverlay } from '../ImageGalleryOverlay';

export const Welcome = () => {
  const { onRedirect } = useRedirect(LKFOnboardingRoutes.CITIZEN_HUB);

  return (
    <ModalCard>
      <OnboardingGrid>
        <Grid.Column>
          <ImageGalleryOverlay
            imageSrc={welcomeImgSrc}
            overlayIntl="onboardingWelcomeTitle"
          />
        </Grid.Column>

        <Grid.Column>
          <Brikk.Heading heading="onboardingWelcomeHeading">
            <Text
              size={18}
              intl="onboardingWelcomeDescription"
            />
          </Brikk.Heading>
        </Grid.Column>

        <NextStep onClick={() => onRedirect()} />
      </OnboardingGrid>
    </ModalCard>
  );
};
